export type DocumentSaveActionType = "save" | "post" | "activate" | "rs";

const handleFormSubmit = async (
  action: DocumentSaveActionType,
  data: any,
  model: any,
  saveHandler: (newModel: any, action: DocumentSaveActionType) => Promise<void>,
  postHandler: (action: DocumentSaveActionType) => Promise<void>
) => {
  const newModel = { ...model, ...data };
  if (action === "save" || action === "activate") {
    console.log("new model");
    console.log(newModel);
    await saveHandler(newModel, action);
  } else if (action === "post" || action === "rs") {
    await saveHandler(newModel, action);
    await postHandler(action);
  }
};

export default handleFormSubmit;
